import React from 'react';
const bullets = ['Noches repasando conversaciones que ya no podés cambiar', 'Anticipando todo lo que puede salir mal mañana mientras deberías estar durmiendo', 'Probaste respirar profundo, contar ovejas... y nada funciona de verdad', 'Abrís el celular solo un momento y una hora después seguís ahí', 'Te levantás más cansado/a que cuando te acostaste', 'Llevás este ciclo hace meses o años y ya no sabés si es normal', 'Cada mañana con ese peso encima antes de abrir los ojos'];
export function PainAgitation() {
  return <section className="bg-white py-12 md:py-24 px-4" data-id="element-309">
      <div className="max-w-[720px] mx-auto text-center" data-id="element-310">
        <h2 className="font-display font-bold text-navy text-[28px] md:text-[40px] leading-tight mb-8" data-id="element-311">
          ¿Cuántas noches más vas a quedarte
          <br data-id="element-312" />
          mirando el techo sin poder apagar la mente?
        </h2>

        <div className="space-y-6 text-[#2D2D2D] font-sans text-lg mb-12" data-id="element-313">
          <p data-id="element-314">Tu cuerpo pide descanso.</p>
          <p data-id="element-315">Pero tu mente no tiene botón de apagado.</p>
          <p data-id="element-316">No es debilidad.</p>
          <p data-id="element-317">No es que te preocupás demasiado.</p>
          <p data-id="element-318">No es que no lo intentaste suficiente.</p>
          <p data-id="element-319">
            Es que nadie te dio las herramientas correctas para lo que realmente
            pasa en tu sistema nervioso cuando intentás dormir.
          </p>
        </div>

        <div className="grid gap-4 text-left mb-16" data-id="element-320">
          {bullets.map((bullet, i) => <div key={i} className="bg-cream p-4 px-5 rounded-xl flex gap-4 items-start" data-id="element-321">
              <span className="text-terracotta text-xl shrink-0" data-id="element-322">❌</span>
              <p className="text-[#2D2D2D] font-sans font-medium" data-id="element-323">{bullet}</p>
            </div>)}
        </div>

        <div className="flex flex-col items-center gap-4" data-id="element-324">
          <div className="flex items-center gap-4 w-full max-w-xs" data-id="element-325">
            <div className="h-px bg-gold/60 flex-grow" data-id="element-326"></div>
            <span className="text-gold" data-id="element-327">✦</span>
            <div className="h-px bg-gold/60 flex-grow" data-id="element-328"></div>
          </div>
          <p className="font-display italic text-sage text-2xl" data-id="element-329">
            ¿Y si esta fuera la última noche
            <br data-id="element-330" />
            que lo atravesás completamente solo/a?
          </p>
          <div className="flex items-center gap-4 w-full max-w-xs" data-id="element-331">
            <div className="h-px bg-gold/60 flex-grow" data-id="element-332"></div>
            <span className="text-gold" data-id="element-333">✦</span>
            <div className="h-px bg-gold/60 flex-grow" data-id="element-334"></div>
          </div>
        </div>
      </div>
    </section>;
}